import { UI } from '@taraai/types';
import DraggableFeatureCardList from 'components/app/controllers/DraggableFeatureCardList';
import BacklogTaskHeader from 'components/app/controllers/views/BacklogTaskHeader';
import { css } from 'emotion';
import React from 'react';

export interface BacklogTasksProps {
  tasks: UI.UITask[];
  toggleModal: (task: UI.UITask) => void;
  getGroups: () => void;
}

/**
 * BacklogTasks does…
 *
 */
function BacklogTasks({ tasks = [], getGroups, toggleModal }: BacklogTasksProps): JSX.Element {
  return (
    <>
      <div
        className={css`
          padding: 1rem 0.5rem 1.125rem 0.5rem;
          background-color: #ffffff;
          border-bottom: 0.0625rem solid #eaeef5;
        `}
      >
        <BacklogTaskHeader backlogTaskCount={tasks.length} getGroups={getGroups} />
      </div>
      {tasks.length > 0 && (
        <div
          className={css`
            height: 90%;
            overflow: auto;
          `}
        >
          <DraggableFeatureCardList disableOrdering tasks={tasks} toggleModal={toggleModal} />
        </div>
      )}
    </>
  );
}

export default BacklogTasks;
